import { ContentTypeEnumForBackend, ContentModalContentType, ContentTypeForComparison } from 'domains/content/types';
import { URLPaths } from 'models/enums';
import { isRootFolder } from 'utils/folders';

const getBasePathByContentType = (contentType: ContentTypeForComparison): string => {
    switch (contentType) {
        case ContentTypeForComparison.EMAIL:
            return URLPaths.CONTENT_CREATE_EMAIL;
        case ContentTypeForComparison.LANDING_PAGE:
            return URLPaths.CONTENT_CREATE_PAGE;
        case ContentTypeForComparison.SMS:
            return URLPaths.CONTENT_CREATE_SMS;
        case ContentTypeForComparison.DIRECT_MAIL:
            return URLPaths.CONTENT_CREATE_DIRECT_MAIL;
        case ContentTypeForComparison.VOICE:
            return URLPaths.CONTENT_CREATE_VOICE_CALL;
        default:
            return URLPaths.CONTENT;
    }
};

export const getContentCreatePath = ({
    contentType,
    id,
    isCopy,
    parentFolderId,
}: {
    contentType: ContentTypeForComparison;
    id?: number;
    isCopy?: boolean;
    parentFolderId?: number;
}) => {
    const basePath = getBasePathByContentType(contentType);

    const isVoiceCall = contentType === ContentTypeForComparison.VOICE;

    const queryParams: Record<string, string> = {};

    if (!isVoiceCall) {
        queryParams.id = id?.toString() ?? 'default';
    } else if (id) {
        queryParams.id = id.toString();
    }

    if (isCopy) {
        queryParams.isCopy = 'true';
    }

    if (parentFolderId && !isRootFolder(parentFolderId)) {
        queryParams.parentFolderId = parentFolderId.toString();
    }

    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${basePath}?${queryString}` : basePath;
};

export const getContentType = (content?: ContentModalContentType) => {
    if (content?.type === 'voice') {
        return 'Voice Call';
    }
    return content?.type;
};
export function contentTypeToSnakeCase(type: keyof typeof ContentTypeEnumForBackend): string {
    return ContentTypeEnumForBackend[type] || '';
}
